import { render, staticRenderFns } from "./ContactsComponent.vue?vue&type=template&id=b7df1848"
import script from "./ContactsComponent.vue?vue&type=script&lang=js"
export * from "./ContactsComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactsComponent.vue?vue&type=style&index=0&id=b7df1848&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports